import { render, staticRenderFns } from "./Address.m.vue?vue&type=template&id=2be98721&scoped=true&"
import script from "./Address.m.vue?vue&type=script&lang=js&"
export * from "./Address.m.vue?vue&type=script&lang=js&"
import style0 from "./Address.m.vue?vue&type=style&index=0&id=2be98721&lang=scss&scoped=true&"
import style1 from "./Address.m.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be98721",
  null
  
)

export default component.exports